import { roundCurrency } from './currency';

export const PARTIAL_PAYMENT_MATCH_THRESHOLD = 0;

export const isPartialPaymentMatchBalanceEligible = (remainingBalance) => {
  const balance = Number(remainingBalance);
  return Number.isFinite(balance) && balance > PARTIAL_PAYMENT_MATCH_THRESHOLD;
};

export const getPartialPaymentMatchOffer = ({
  remainingBalance,
  paymentAmount,
}) => {
  const amount = Number(paymentAmount);
  const isBalanceEligible = isPartialPaymentMatchBalanceEligible(remainingBalance);
  const isPaymentEligible =
    Number.isFinite(amount) && amount > PARTIAL_PAYMENT_MATCH_THRESHOLD;
  const paymentCredit = Number.isFinite(amount) ? amount : 0;

  return {
    isBalanceEligible,
    isPaymentEligible,
    matchAmount: 0,
    threshold: PARTIAL_PAYMENT_MATCH_THRESHOLD,
    totalBalanceReduction: roundCurrency(paymentCredit),
  };
};
